import { createContext } from 'react'

export interface FontOption {
  name: string
  value: string
  category: 'sans-serif' | 'serif' | 'monospace' | 'display'
}

export interface FontContextType {
  currentFont: FontOption
  setFont: (font: FontOption) => void
  availableFonts: FontOption[]
  isLoading: boolean
}

export const FontContext = createContext<FontContextType | undefined>(undefined)
